const canUseDOM = !!(typeof window !== 'undefined' &&
    window.document &&
    window.document.createElement);
const getScrollbarWidth = () => {
    let width = 0;
    if (typeof window !== 'undefined') {
        if (window.scrollbarWidth &&
            document.body.scrollHeight > window.innerHeight) {
            return window.scrollbarWidth;
        }
        const outer = document.createElement('div');
        outer.style.visibility = 'hidden';
        outer.style.overflow = 'scroll';
        document.body.appendChild(outer);
        const inner = document.createElement('div');
        outer.appendChild(inner);
        width = outer.offsetWidth - inner.offsetWidth;
        outer.parentNode.removeChild(outer);
        window.scrollbarWidth = width;
    }
    return width;
};
const getMoneyValueUnit = (value) => {
    if (value < 1000000)
        return { value: Math.round((value / 1000) * 1000) / 1000, unit: 'K' };
    if (value > 1000000000)
        return {
            value: Math.round((value / 1000000000) * 1000) / 1000,
            unit: 'tỷ',
        };
    return { value: Math.round((value / 1000000) * 1000) / 1000, unit: 'tr' };
};
const getImageUrlFromGoogleUserContent = (imageUrl, imageWidth) => {
    let result = imageUrl;
    if (imageUrl.includes('googleusercontent.com')) {
        if (imageWidth) {
            result = `${imageUrl}=w${imageWidth}`;
        }
    }
    return result;
};

export { getMoneyValueUnit as a, getImageUrlFromGoogleUserContent as b, canUseDOM as c, getScrollbarWidth as g };
